import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Select from "react-select";
import { Decrypt_Id_Name, isLockOrRestrictModule, LockFildscolour, Requiredcolour } from '@/Components/Common/Utility';
import { get_TypeMarijuana_Drp_Data, GetDataDropDown_PrecursorChemicalsMeasureType } from '@/redux/actions/DropDownsData';
import { AgencyContext } from 'Context/Agency';
import PropListng from '@/Components/Pages/ShowAllList/PropListng';
import { get_LocalStoreData } from '@/redux/actions/Agency';
import { AddDeleteUpadate, fetchPostData } from '@/Components/hooks/Api';
import { toastifySuccess, toastifyError } from '@/Components/Common/AlertMsg';
import { useLocation } from 'react-router-dom';
import ChangesModal from '@/Components/Common/ChangesModal';
import { get_ScreenPermissions_Data } from '@/redux/actions/IncidentAction';
import DataTable from '@/Components/Common/DataTableWithAutoPagination';
import { tableCustomStyles } from '@/Components/Common/Utility';
import DeletePopUpModal from '@/Components/Common/DeleteModal';

const Other = (props) => {

    const { ListData, DecPropID, DecMPropID, DecIncID, isViewEventDetails = false, isLocked, setIsLocked } = props
    const { setChangesStatus, changesStatus, } = useContext(AgencyContext);

    const useQuery = () => {
        const params = new URLSearchParams(useLocation().search);
        return {
            get: (param) => params.get(param)
        };
    };

    const query = useQuery();
    let MstPage = query?.get('page');

    const dispatch = useDispatch();
    const localStoreData = useSelector((state) => state.Agency.localStoreData);
    const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';
    const typeMarijuanaDrpData = useSelector((state) => state.DropDown.typeMarijuanaDrpData);
    const effectiveScreenPermission = useSelector((state) => state.Incident.effectiveScreenPermission);
    const precursorChemicalsMeasureTypeDrpData = useSelector((state) => state.DropDown.precursorChemicalsMeasureTypeDrpData);
    const [loginAgencyID, setLoginAgencyID] = useState('');
    const [loginPinID, setLoginPinID,] = useState('');
    const [editval, setEditval] = useState([]);
    const [statesChangeStatus, setStatesChangeStatus] = useState(false);
    // Add Update Permission
    const [addUpdatePermission, setaddUpdatePermission] = useState();

    const [value, setValue] = useState({
        'MarijuanaType': '', 'MarijuanaItems': '', 'NumMethLabs': '', 'NumAmphetamineLabs': '', 'NumP2PLabs': '',
        'NumPCPLabs': '', 'NumCrackLabs': '', 'NumOtherControlledSubstanceLabs': '',
        'PropertyID': '', 'MasterPropertyID': '', 'ModifiedByUserFK': '', 'IsMaster': MstPage === "MST-Property-Dash" ? true : false,
    });

    // Precursor Chemical Info State
    const [precursorChemicalData, setPrecursorChemicalData] = useState([]);
    const [precursorChemicalForm, setPrecursorChemicalForm] = useState({
        'Quantity': '',
        'MeasurementType': null,
        'PrecursorChemicalID': null,
        'PropertyID': DecPropID,
        'MasterPropertyID': DecMPropID,
    });
    const [isEditPrecursor, setIsEditPrecursor] = useState(false);
    const [delPrecursorChemicalID, setDelPrecursorChemicalID] = useState(null);
    const [precursorChemicalErrors, setPrecursorChemicalErrors] = useState({
        'QuantityError': '',
        'MeasurementTypeError': '',
    });
    const [precursorChemicalChangeStatus, setPrecursorChemicalChangeStatus] = useState(false);

    useEffect(() => {
        if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
            if (uniqueId) dispatch(get_LocalStoreData(uniqueId));
        }
    }, []);

    useEffect(() => {
        if (localStoreData) {
            setLoginAgencyID(localStoreData?.AgencyID); setLoginPinID(localStoreData?.PINID);
            dispatch(get_ScreenPermissions_Data("P091", localStoreData?.AgencyID, localStoreData?.PINID));
            dispatch(GetDataDropDown_PrecursorChemicalsMeasureType(localStoreData?.AgencyID));
        }
    }, [localStoreData]);

    useEffect(() => {
        if (localStoreData?.AgencyID) {
            if (typeMarijuanaDrpData?.length === 0) dispatch(get_TypeMarijuana_Drp_Data(localStoreData?.AgencyID));
        }
    }, [localStoreData?.AgencyID]);

    const GetPrecursorChemicalData = (propertyID, masterPropertyID) => {
        const val = {
            PropertyID: propertyID,
            MasterPropertyID: masterPropertyID
        }
        fetchPostData('PrecursorChemical/GetData_PrecursorChemical', val).then((res) => {
            if (res) {
                setPrecursorChemicalData(res);
            } else {
                setPrecursorChemicalData([]);
            }
        })
    }

    useEffect(() => {
        if (DecPropID || DecMPropID) {
            GetSingleData(DecPropID, DecMPropID);
            GetPrecursorChemicalData(DecPropID, DecMPropID);
        }
    }, [DecPropID]);

    const GetSingleData = (propertyID, masterPropertyID) => {
        const val = { PropertyID: propertyID, MasterPropertyID: masterPropertyID, 'IsMaster': MstPage === "MST-Property-Dash" ? true : false, }
        const val2 = { MasterPropertyID: masterPropertyID, PropertyID: 0, 'IsMaster': MstPage === "MST-Property-Dash" ? true : false, }
        fetchPostData('Property/GetSingleData_Property', MstPage === "MST-Property-Dash" ? val2 : val).then((res) => {
            if (res) {

                setEditval(res);
            } else { setEditval([]); }
        })
    }

    useEffect(() => {
        if (editval?.length > 0) {
            setValue({
                ...value,
                'MarijuanaType': editval[0]?.MarijuanaType ? parseInt(editval[0]?.MarijuanaType) : null,
                'MarijuanaItems': editval[0]?.NumFields || '',
                'NumMethLabs': editval[0]?.NumOfMethLabs || '',
                'NumAmphetamineLabs': editval[0]?.NumOfAmphetamineLabs || '',
                'NumP2PLabs': editval[0]?.NumOfP2PLabs || '',
                'NumPCPLabs': editval[0]?.NumOfPCPLabs || '',
                'NumCrackLabs': editval[0]?.NumOfCrackLabs || '',
                'NumOtherControlledSubstanceLabs': editval[0]?.NumOfControlledLabs || '',
                'PropertyID': DecPropID, 'MasterPropertyID': DecPropID, 'ModifiedByUserFK': loginPinID,
            })
            setStatesChangeStatus(false);
        }
    }, [editval])

    const check_Validation_Error = () => {
        updateMarijuna()
    }

    const updateMarijuna = () => {
        const { MarijuanaType, MarijuanaItems, NumMethLabs, NumAmphetamineLabs, NumP2PLabs, NumPCPLabs, NumCrackLabs, NumOtherControlledSubstanceLabs, PropertyID, MasterPropertyID, IsMaster } = value
        const val = {
            'MarijuanaType': MarijuanaType || null,
            'NumFields': MarijuanaItems || '',
            'NumOfMethLabs': NumMethLabs || '',
            'NumOfAmphetamineLabs': NumAmphetamineLabs || '',
            'NumOfP2PLabs': NumP2PLabs || '',
            'NumOfPCPLabs': NumPCPLabs || '',
            'NumOfCrackLabs': NumCrackLabs || '',
            'NumOfControlledLabs': NumOtherControlledSubstanceLabs || '',
            'PropertyID': DecPropID, 'MasterPropertyID': DecMPropID, 'IsMaster': IsMaster, 'ModifiedByUserFK': loginPinID,
        }


        AddDeleteUpadate('Property/Update_MiscellaneousInformation', val).then((res) => {
            const parsedData = JSON.parse(res.data);
            const message = parsedData.Table[0].Message;
            toastifySuccess(message);
            setChangesStatus(false); setStatesChangeStatus(false);
            GetSingleData(DecPropID, DecMPropID)
        })
    }

    const Reset = () => {
        setValue({
            ...value,
            'MarijuanaType': null,
            'MarijuanaItems': '', 'NumMethLabs': '', 'NumAmphetamineLabs': '', 'NumP2PLabs': '',
            'NumPCPLabs': '', 'NumCrackLabs': '', 'NumOtherControlledSubstanceLabs': ''
        });
        setStatesChangeStatus(false);
    }

    const HandleChanges = (e) => {
        !addUpdatePermission && setStatesChangeStatus(true); !addUpdatePermission && setChangesStatus(true)
        if (e) {
            const inputValue = e.target.value;
            // Only allow single digit (0-9)
            if (inputValue === '' || (inputValue.length <= 1 && /^\d$/.test(inputValue))) {
                setValue({
                    ...value,
                    [e.target.name]: inputValue
                })
            }
        }
    }

    const ChangeDropDown = (e, name) => {
        !addUpdatePermission && setStatesChangeStatus(true); !addUpdatePermission && setChangesStatus(true)
        if (e) {
            setValue({ ...value, [name]: e.value });
        } else {
            setValue({ ...value, [name]: null });
        }
    }

    const customStylesWithOutColor = {
        control: base => ({
            ...base,
            height: 20,
            minHeight: 35,
            fontSize: 14,
            margintop: 2,
            boxShadow: 0,
        }),
    };

    // Precursor Chemical Functions
    const handlePrecursorChemicalChange = (e) => {
        setPrecursorChemicalChangeStatus(true);
        if (e?.target) {
            const { name, value } = e.target;
            if (name === 'Quantity') {
                const numericValue = value.replace(/[^0-9.]/g, '');
                if (numericValue.length <= 7) {
                    // If Quantity is cleared, also clear MeasurementType
                    const updatedForm = { ...precursorChemicalForm, [name]: numericValue };
                    if (!numericValue || numericValue.trim() === '') {
                        updatedForm.MeasurementType = null;
                    }
                    setPrecursorChemicalForm(updatedForm);
                    if (precursorChemicalErrors.QuantityError) {
                        setPrecursorChemicalErrors({ ...precursorChemicalErrors, 'QuantityError': '' });
                    }
                    // Clear MeasurementType error if Quantity is cleared
                    if ((!numericValue || numericValue.trim() === '') && precursorChemicalErrors.MeasurementTypeError) {
                        setPrecursorChemicalErrors({ ...precursorChemicalErrors, 'MeasurementTypeError': '' });
                    }
                }
            } else {
                setPrecursorChemicalForm({ ...precursorChemicalForm, [name]: value });
            }
        } else {
            setPrecursorChemicalForm({ ...precursorChemicalForm, 'MeasurementType': e });
            if (precursorChemicalErrors.MeasurementTypeError) {
                setPrecursorChemicalErrors({ ...precursorChemicalErrors, 'MeasurementTypeError': '' });
            }
        }
        !addUpdatePermission && setChangesStatus(true);
    };

    const handleNewPrecursorChemical = () => {
        setPrecursorChemicalForm({
            'Quantity': '',
            'MeasurementType': null,
            'PrecursorChemicalID': null,
            'PropertyID': DecPropID,
            'MasterPropertyID': DecMPropID,
        });
        setIsEditPrecursor(false);
        setPrecursorChemicalErrors({
            'QuantityError': '',
            'MeasurementTypeError': '',
        });
        setPrecursorChemicalChangeStatus(false);
    };

    const handleSavePrecursorChemical = () => {
        const errors = {
            'QuantityError': '',
            'MeasurementTypeError': '',
        };

        let hasError = false;

        // Check if Quantity has a value
        const hasQuantity = precursorChemicalForm.Quantity && precursorChemicalForm.Quantity.trim() !== '';

        // If Quantity has a value, MeasurementType is required
        if (hasQuantity && !precursorChemicalForm.MeasurementType) {
            errors.MeasurementTypeError = 'Required';
            hasError = true;
        }

        setPrecursorChemicalErrors(errors);

        if (hasError) {
            return;
        }

        if (isEditPrecursor) {
            // Update API
            const payload = {
                'PrecursorChemicalID': precursorChemicalForm.PrecursorChemicalID,
                'PrecursorChemicalTypeID': precursorChemicalForm.MeasurementType?.value || precursorChemicalForm.MeasurementType,
                'PrecursorChemicalQty': precursorChemicalForm.Quantity || '',
                'ModifiedByUserFK': loginPinID,

                'IsMaster': MstPage === "MST-Property-Dash" ? "true" : "false"
            };

            AddDeleteUpadate('PrecursorChemical/Update_PrecursorChemical', payload).then((res) => {
                if (res) {
                    toastifySuccess('Precursor Chemical updated successfully');
                    GetPrecursorChemicalData(DecPropID, DecMPropID);
                    handleNewPrecursorChemical();
                    setStatesChangeStatus(false);
                    setChangesStatus(false);
                    setPrecursorChemicalChangeStatus(false);
                    setPrecursorChemicalErrors({
                        'QuantityError': '',
                        'MeasurementTypeError': '',
                    });
                } else {
                    toastifyError('Failed to update Precursor Chemical');
                }
            }).catch((error) => {
                toastifyError('Error updating Precursor Chemical: ' + (error.message || 'Unknown error'));
            });
        } else {
            // Insert API
            const payload = {
                'MasterPropertyID': DecMPropID,
                'PropertyID': DecPropID,
                'PrecursorChemicalTypeID': precursorChemicalForm.MeasurementType?.value || precursorChemicalForm.MeasurementType,
                'PrecursorChemicalQty': precursorChemicalForm.Quantity || '',
                'CreatedByUserFK': loginPinID,
                'IsMaster': MstPage === "MST-Property-Dash" ? "true" : "false"
            };

            AddDeleteUpadate('PrecursorChemical/Insert_PrecursorChemical', payload).then((res) => {
                if (res) {
                    toastifySuccess('Precursor Chemical added successfully');
                    GetPrecursorChemicalData(DecPropID, DecMPropID);
                    handleNewPrecursorChemical();
                    setStatesChangeStatus(false);
                    setChangesStatus(false);
                    setPrecursorChemicalChangeStatus(false);
                    setPrecursorChemicalErrors({
                        'QuantityError': '',
                        'MeasurementTypeError': '',
                    });
                } else {
                    toastifyError('Failed to add Precursor Chemical');
                }
            }).catch((error) => {
                toastifyError('Error adding Precursor Chemical: ' + (error.message || 'Unknown error'));
            });
        }
    };

    const handleEditPrecursorChemical = (row) => {
        setPrecursorChemicalForm({
            'Quantity': row.PrecursorChemicalQty || row.Quantity || '',
            'MeasurementType': precursorChemicalsMeasureTypeDrpData.find(opt => opt.value === (row.PrecursorChemicalTypeID || row.MeasurementType)) || null,
            'PrecursorChemicalID': row.PropertyPrecursorChemicalID,
            'PropertyID': DecPropID,
            'MasterPropertyID': DecMPropID,
        });
        setIsEditPrecursor(true);
        setPrecursorChemicalChangeStatus(false);
    };

    const Delete_PrecursorChemical = () => {
        const val = {
            'PrecursorChemicalID': delPrecursorChemicalID,
            'PropertyID': DecPropID,
            'MasterPropertyID': DecMPropID,
            'DeletedByUserFK': loginPinID
        };
        AddDeleteUpadate('PrecursorChemical/Delete_PrecursorChemical', val).then((res) => {
            if (res) {
                toastifySuccess('Precursor Chemical deleted successfully');
                GetPrecursorChemicalData(DecPropID, DecMPropID);
                setDelPrecursorChemicalID(null);
            } else {
                toastifyError('Failed to delete Precursor Chemical');
            }
        }).catch((error) => {
            toastifyError('Error deleting Precursor Chemical: ' + (error.message || 'Unknown error'));
        });
    };

    const precursorChemicalColumns = [
        {
            name: 'Quantity',
            selector: (row) => row.PrecursorChemicalQty || row.Quantity || '',
            sortable: true,
        },
        {
            name: 'Measurement Type',
            selector: (row) => {
                const typeId = row.PrecursorChemicalTypeID || row.MeasurementType;
                const typeOption = precursorChemicalsMeasureTypeDrpData?.find(opt => opt.value === typeId);
                return typeOption?.label || typeId || '';
            },
            sortable: true,
        },
        {
            name: <p className='text-end' style={{ position: 'absolute', top: 8, right: 10 }}>Action</p>,
            cell: row =>
                <div style={{ position: 'absolute', top: 4, right: 10 }}>
                    <button
                        onClick={() => { setDelPrecursorChemicalID(row.PropertyPrecursorChemicalID); }}
                        className="btn btn-sm bg-green text-white px-1 py-0 mr-1"
                        data-toggle="modal"
                        data-target="#DeleteModal"
                    >
                        <i className="fa fa-trash"></i>
                    </button>
                </div>
        },
    ];

    return (
        <>
            <PropListng {...{ ListData }} />
            <fieldset>
                <legend>Drug Manufactured Info</legend>
                <div className="col-12">
                    <div className="row mt-1">
                        <div className="col-4 col-md-4 col-lg-3  mt-3">
                            <label htmlFor="" className='new-label'>Type Marijuana Fields and Gardens</label>
                        </div>
                        <div className="col-8 col-md-8 col-lg-3 mt-2">
                            <Select
                                name='MarijuanaType'
                                value={typeMarijuanaDrpData?.filter((obj) => obj.value === value?.MarijuanaType)}
                                options={typeMarijuanaDrpData}
                                onChange={(e) => ChangeDropDown(e, 'MarijuanaType')}
                                isClearable
                                placeholder="Select..."
                                styles={isLockOrRestrictModule("Lock", editval[0]?.MarijuanaType, isLocked) ? LockFildscolour : Requiredcolour}
                                isDisabled={isLockOrRestrictModule("Lock", editval[0]?.MarijuanaType, isLocked) ? true : false}
                            />
                        </div>

                        <div className="col-4 col-md-4 col-lg-3  mt-3">
                            <label htmlFor="" className='new-label'># Marijuana Items</label>
                        </div>
                        <div className="col-8 col-md-8 col-lg-3 mt-2 text-field">
                            <input
                                type="number"
                                name='MarijuanaItems'
                                id='MarijuanaItems'
                                maxLength={1}
                                max={9}
                                min={0}
                                value={value?.MarijuanaItems || ''}
                                onChange={HandleChanges}
                                autoComplete='off'
                                className={isLockOrRestrictModule("Lock", editval[0]?.MarijuanaItems, isLocked) ? "LockFildsColor" : ''}
                                disabled={isLockOrRestrictModule("Lock", editval[0]?.MarijuanaItems, isLocked)}
                            />
                        </div>

                        <div className="col-4 col-md-4 col-lg-3  mt-3">
                            <label htmlFor="" className='new-label'>Number of Meth Labs</label>
                        </div>
                        <div className="col-8 col-md-8 col-lg-3 mt-2 text-field">
                            <input
                                type="number"
                                name='NumMethLabs'
                                id='NumMethLabs'
                                maxLength={1}
                                max={9}
                                min={0}
                                value={value?.NumMethLabs || ''}
                                onChange={HandleChanges}
                                autoComplete='off'
                                className={isLockOrRestrictModule("Lock", editval[0]?.NumMethLabs, isLocked) ? "LockFildsColor" : ''}
                                disabled={isLockOrRestrictModule("Lock", editval[0]?.NumMethLabs, isLocked)}
                            />
                        </div>

                        <div className="col-4 col-md-4 col-lg-3  mt-3">
                            <label htmlFor="" className='new-label'>Number of Amphetamine Labs</label>
                        </div>
                        <div className="col-8 col-md-8 col-lg-3 mt-2 text-field">
                            <input
                                type="number"
                                name='NumAmphetamineLabs'
                                id='NumAmphetamineLabs'
                                maxLength={1}
                                max={9}
                                min={0}
                                value={value?.NumAmphetamineLabs || ''}
                                onChange={HandleChanges}
                                autoComplete='off'
                                className={isLockOrRestrictModule("Lock", editval[0]?.NumAmphetamineLabs, isLocked) ? "LockFildsColor" : ''}
                                disabled={isLockOrRestrictModule("Lock", editval[0]?.NumAmphetamineLabs, isLocked)}
                            />
                        </div>

                        <div className="col-4 col-md-4 col-lg-3  mt-3">
                            <label htmlFor="" className='new-label'>Number of P2P Labs</label>
                        </div>
                        <div className="col-8 col-md-8 col-lg-3 mt-2 text-field">
                            <input
                                type="number"
                                name='NumP2PLabs'
                                id='NumP2PLabs'
                                maxLength={1}
                                max={9}
                                min={0}
                                value={value?.NumP2PLabs || ''}
                                onChange={HandleChanges}
                                autoComplete='off'
                                className={isLockOrRestrictModule("Lock", editval[0]?.NumP2PLabs, isLocked) ? "LockFildsColor" : ''}
                                disabled={isLockOrRestrictModule("Lock", editval[0]?.NumP2PLabs, isLocked)}
                            />
                        </div>

                        <div className="col-4 col-md-4 col-lg-3  mt-3">
                            <label htmlFor="" className='new-label'>Number of PCP Labs</label>
                        </div>
                        <div className="col-8 col-md-8 col-lg-3 mt-2 text-field">
                            <input
                                type="number"
                                name='NumPCPLabs'
                                id='NumPCPLabs'
                                maxLength={1}
                                max={9}
                                min={0}
                                value={value?.NumPCPLabs || ''}
                                onChange={HandleChanges}
                                autoComplete='off'
                                className={isLockOrRestrictModule("Lock", editval[0]?.NumPCPLabs, isLocked) ? "LockFildsColor" : ''}
                                disabled={isLockOrRestrictModule("Lock", editval[0]?.NumPCPLabs, isLocked)}
                            />
                        </div>

                        <div className="col-4 col-md-4 col-lg-3  mt-3">
                            <label htmlFor="" className='new-label'>Number of Crack Labs</label>
                        </div>
                        <div className="col-8 col-md-8 col-lg-3 mt-2 text-field">
                            <input
                                type="number"
                                name='NumCrackLabs'
                                id='NumCrackLabs'
                                maxLength={1}
                                max={9}
                                min={0}
                                value={value?.NumCrackLabs || ''}
                                onChange={HandleChanges}
                                autoComplete='off'
                                className={isLockOrRestrictModule("Lock", editval[0]?.NumCrackLabs, isLocked) ? "LockFildsColor" : ''}
                                disabled={isLockOrRestrictModule("Lock", editval[0]?.NumCrackLabs, isLocked)}
                            />
                        </div>

                        <div className="col-4 col-md-4 col-lg-3  mt-3">
                            <label htmlFor="" className='new-label'>Number of Other Controlled Substance Labs</label>
                        </div>
                        <div className="col-8 col-md-8 col-lg-3 mt-2 text-field">
                            <input
                                type="number"
                                name='NumOtherControlledSubstanceLabs'
                                id='NumOtherControlledSubstanceLabs'
                                maxLength={1}
                                max={9}
                                min={0}
                                value={value?.NumOtherControlledSubstanceLabs || ''}
                                onChange={HandleChanges}
                                autoComplete='off'
                                className={isLockOrRestrictModule("Lock", editval[0]?.NumOtherControlledSubstanceLabs, isLocked) ? "LockFildsColor" : ''}
                                disabled={isLockOrRestrictModule("Lock", editval[0]?.NumOtherControlledSubstanceLabs, isLocked)}
                            />
                        </div>
                    </div>

                    {/* {!isViewEventDetails && */}
                    <div className="col-12 col-md-12 col-lg-12 mt-2 mb-1 text-right">
                        {
                            effectiveScreenPermission ?
                                effectiveScreenPermission[0]?.Changeok ?
                                    <button type="button" disabled={!statesChangeStatus} className="btn btn-md py-1 btn-success" onClick={() => { check_Validation_Error() }}>Update</button>
                                    :
                                    <>
                                    </>
                                :
                                <button type="button" disabled={!statesChangeStatus} className="btn btn-md py-1 btn-success" onClick={() => { check_Validation_Error() }}>Update</button>
                        }
                    </div>
                    {/* } */}

                </div>
            </fieldset>
            <fieldset>
                <legend>Precursor Chemical Info</legend>
                <div className="col-12">
                    <div className="row mt-1">
                        <div className="col-4 col-md-4 col-lg-3  mt-3">
                            <label htmlFor="" className='new-label'>
                                Quantity of Precursor Chemicals
                                {precursorChemicalErrors.QuantityError && (
                                    <p style={{ color: 'red', fontSize: '13px', margin: '0px', padding: '0px' }}>{precursorChemicalErrors.QuantityError}</p>
                                )}
                            </label>
                        </div>
                        <div className="col-8 col-md-8 col-lg-3 mt-2 text-field">
                            <input
                                type="number"
                                name='Quantity'
                                id='Quantity'
                                maxLength={7}
                                max={9999999}
                                min={0}
                                value={precursorChemicalForm?.Quantity || ''}
                                onChange={handlePrecursorChemicalChange}
                                autoComplete='off'
                            />
                        </div>

                        <div className="col-4 col-md-4 col-lg-3  mt-3">
                            <label htmlFor="" className='new-label'>
                                Type Measurement for Precursor Chemicals
                                {precursorChemicalErrors.MeasurementTypeError && (
                                    <p style={{ color: 'red', fontSize: '13px', margin: '0px', padding: '0px' }}>{precursorChemicalErrors.MeasurementTypeError}</p>
                                )}
                            </label>
                        </div>
                        <div className="col-8 col-md-8 col-lg-3 mt-2">
                            <Select
                                name='MeasurementType'
                                value={precursorChemicalForm?.MeasurementType}
                                options={precursorChemicalsMeasureTypeDrpData}
                                onChange={(e) => handlePrecursorChemicalChange(e)}
                                isClearable
                                placeholder="Select..."
                                menuPlacement="top"
                                styles={{
                                    ...(!!precursorChemicalForm?.Quantity ? Requiredcolour : customStylesWithOutColor),
                                    menu: (base) => ({
                                        ...base,
                                        maxHeight: '200px',
                                    }),
                                    menuList: (base) => ({
                                        ...base,
                                        maxHeight: '200px',
                                    }),
                                }}
                            />
                        </div>
                    </div>

                    <div className="col-12 col-md-12 col-lg-12 mt-2 mb-1 text-right">
                        <button
                            type="button"
                            className="btn btn-md py-1 btn-primary mr-2"
                            onClick={handleNewPrecursorChemical}
                        >
                            New
                        </button>
                        <button
                            type="button"
                            className="btn btn-md py-1 btn-success"
                            onClick={handleSavePrecursorChemical}
                            disabled={!precursorChemicalChangeStatus}
                        >
                            {isEditPrecursor ? 'Update' : 'Save'}
                        </button>
                    </div>

                    <div className="col-12 mt-3">
                        <DataTable
                            dense
                            fixedHeader
                            persistTableHead={true}
                            customStyles={tableCustomStyles}
                            columns={precursorChemicalColumns}
                            data={precursorChemicalData}
                            highlightOnHover
                            responsive
                            onRowClicked={(row) => handleEditPrecursorChemical(row)}
                            fixedHeaderScrollHeight='300px'
                            pagination
                            paginationPerPage={10}
                            noDataComponent={'There are no data to display'}
                        />
                    </div>
                </div>
            </fieldset>
            <DeletePopUpModal func={Delete_PrecursorChemical} />
            <ChangesModal func={updateMarijuna} setToReset={Reset} />
        </>
    )
}

export default Other